import React from 'react';

interface Props {
    children?: React.ReactNode;
    className?: string;
}

export default function FormSection({ children, className = '' }: Props) {
    return <div className={`form-section ${className}`.trim()}>{children}</div>;
}
